/**
 * Mobile Demo Mode Context
 * 
 * Provides global demo mode state for the mobile app.
 */

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DemoModeContextType {
  isDemoMode: boolean;
  setIsDemoMode: (value: boolean) => void;
  demoScenario: string;
  setDemoScenario: (scenario: string) => void;
  demoSpeed: number;
  setDemoSpeed: (speed: number) => void;
}

const DemoModeContext = createContext<DemoModeContextType | undefined>(undefined);

export function DemoModeProvider({ children }: { children: ReactNode }) {
  const [isDemoMode, setIsDemoMode] = useState(false);
  const [demoScenario, setDemoScenario] = useState('neurodisability');
  const [demoSpeed, setDemoSpeed] = useState(1);

  return (
    <DemoModeContext.Provider
      value={{
        isDemoMode,
        setIsDemoMode,
        demoScenario,
        setDemoScenario,
        demoSpeed,
        setDemoSpeed,
      }}
    >
      {children}
    </DemoModeContext.Provider>
  );
}

export function useDemoModeContext() {
  const context = useContext(DemoModeContext);
  if (context === undefined) {
    throw new Error('useDemoModeContext must be used within a DemoModeProvider');
  }
  return context;
}
